export default __webpack_public_path__ + "static/media/E-commerceRealCase2-moblie.cd9047e4.jpg";